import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AdminFeedbacksService, UpdateFeedbackCategoryPayload } from './feedbacksApi';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';

const initialState: any = {
    feedbacksAreLoading: false,
    feedbackIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchFeedbacks = createAsyncThunk<any, IPaginationPayload>(
    'adminFeedbacks/tryToFetchFeedbacks',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await AdminFeedbacksService.tryToFetchFeedbacks(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToFetchAllFeedbacks = createAsyncThunk<any, any>(
    'adminFeedbacks/tryToFetchAllFeedbacks',
    async (data: any) => {
        const result = await AdminFeedbacksService.tryToFetchAllFeedbacks(data);
        return result?.data?.data;
    }
);


export const tryToUpdateFeedbackCategory = createAsyncThunk<
  any, // <-- ideally type your Feedback DTO
  { id: string; payload: UpdateFeedbackCategoryPayload }
>('adminFeedbacks/tryToUpdateFeedbackCategory', async ({ id, payload }) => {
  const res = await AdminFeedbacksService.tryToUpdateFeedbackCategory(id, payload);
  return res?.data; // this should be the UPDATED feedback doc (or ApiResponse.data)
});

// ⬇️ NEW: update feedback importance
export const tryToUpdateFeedbackImportance = createAsyncThunk<
  any,
  { id: string; importance: 'High' | 'Medium' | 'Low'; originalImportance?: 'High' | 'Medium' | 'Low' }
>('adminFeedbacks/tryToUpdateFeedbackImportance', async ({ id, importance, originalImportance }) => {
  const res = await AdminFeedbacksService.tryToUpdateFeedbackImportance(id, { importance, originalImportance });
  return res?.data; // this should be the UPDATED feedback doc (or ApiResponse.data)
});


/** PATCH /rebecca-ai-agent/feedbacks/:id — generic update */
export const tryToUpdateFeedback = createAsyncThunk<
  any,
  { id: string; payload: Record<string, any> }
>('adminFeedbacks/tryToUpdateFeedback', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const res = await AdminFeedbacksService.tryToUpdateFeedback(id, payload);
    return res?.data;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data?.message || 'Failed to update feedback');
  }
});

export const adminFeedbacksSlice = createSlice({
    name: 'adminFeedbacks',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchFeedbacks
            .addCase(tryToFetchFeedbacks.pending, (state) => {
                state.feedbacksAreLoading = true;
            })
            .addCase(tryToFetchFeedbacks.rejected, (state) => {
                state.feedbacksAreLoading = false;
            })
            .addCase(tryToFetchFeedbacks.fulfilled, (state, action) => {
                state.feedbacksAreLoading = false;
                state.feedbacks = action.payload;
            })            .addCase(tryToUpdateFeedbackCategory.fulfilled, (state, action) => {
  const updated = action.payload?.data ?? action.payload; // supports ApiResponse.success

  // ✅ your actual list is here
  const list = state.feedbacks?.data?.elements;

  if (!updated?._id || !Array.isArray(list)) return;

  const idx = list.findIndex((x: any) => x._id === updated._id);
  if (idx !== -1) {
    list[idx] = {
      ...list[idx],
      ...updated,
      additionalInfo: {
        ...(list[idx]?.additionalInfo || {}),
        ...(updated?.additionalInfo || {}),
      },
    };
  }
})
            .addCase(tryToUpdateFeedbackImportance.fulfilled, (state, action) => {
  const updated = action.payload?.data ?? action.payload; // supports ApiResponse.success

  // ✅ your actual list is here
  const list = state.feedbacks?.data?.elements;

  if (!updated?._id || !Array.isArray(list)) return;

  const idx = list.findIndex((x: any) => x._id === updated._id);
  if (idx !== -1) {
    list[idx] = {
      ...list[idx],
      ...updated,
      additionalInfo: {
        ...(list[idx]?.additionalInfo || {}),
        ...(updated?.additionalInfo || {}),
      },
    };
  }
})
            .addCase(tryToUpdateFeedback.fulfilled, (state, action) => {
  const updated = action.payload?.data ?? action.payload;
  const list = state.feedbacks?.data?.elements;
  if (!updated?._id || !Array.isArray(list)) return;
  const idx = list.findIndex((x: any) => x._id === updated._id);
  if (idx !== -1) {
    list[idx] = {
      ...list[idx],
      ...updated,
      additionalInfo: {
        ...(list[idx]?.additionalInfo || {}),
        ...(updated?.additionalInfo || {}),
      },
    };
  }
})

    },
});

export default adminFeedbacksSlice.reducer;